var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { axios } from "@inscore/shared";
class StatsApi {
  static getSpecialStats() {
    const abortController = new AbortController();
    return {
      call({ seasonId, subject, family, filters, sortBy, sortDir }) {
        return axios.get(`/v1/SpecialStats/${seasonId}/${subject}`, {
          signal: abortController.signal,
          params: { family, filters, sortBy, sortDir }
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getSpecialStatsFixtures() {
    const abortController = new AbortController();
    return {
      call({
        seasonId,
        teamId,
        metric,
        period,
        location,
        total,
        minuteRange
      }) {
        return axios.get(`/v1/SpecialStats/${seasonId}/fixtures`, {
          signal: abortController.signal,
          params: {
            teamId,
            metric,
            period,
            location,
            total,
            minuteRange
          }
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static searchSpecialStatsLeagues() {
    const abortController = new AbortController();
    return {
      call({ query } = {}) {
        return axios.get(`/v3/Search`, {
          signal: abortController.signal,
          params: __spreadValues({
            type: 5,
            setKey: "country:RU|event:specialstats"
          }, query && { query })
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
  static getSpecialStatsMetaData() {
    const abortController = new AbortController();
    return {
      call() {
        return axios.get(`/v1/SpecialStats/metadata`, {
          signal: abortController.signal
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
}
var stdin_default = StatsApi;
export {
  stdin_default as default
};
